import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../utils/constants/routes';
import { useAuthStore } from '../../stores/authStore';
import { Roles } from '../../utils/enums';
import { Role } from '../../types/auth';

const Dashboard = () => {
    const activeRole = useAuthStore((state) => state.activeRole);
    const history = useHistory();

    useEffect(() => {
        redirectTo([activeRole]);
    }, [activeRole]);

    const redirectTo = (rolesArray: [string]) => {
        const requestor = rolesArray.includes(Roles.REQUESTOR);
        const ops = rolesArray.includes(Roles.OPS_MANAGER);
        const admin = rolesArray.includes(Roles.ADMIN);
        const vendor = rolesArray.includes(Roles.VENDOR) || rolesArray.includes(Roles.THREED_AGENCY) || rolesArray.includes(Roles.THREED_ARTIST) || rolesArray.includes(Roles.THREED_ARTIST_OR_AGENCY);
        if (requestor) {
            history.push(Routes.REQUESTER_ROUTES.ROOT);
        } else if (ops) {
            history.push(Routes.OPS_ROUTES.ROOT);
        } else if (vendor) {
            history.push(Routes.VENDOR_ROUTES.ROOT);
        } else if (admin) {
            history.push(Routes.ADMIN_ROUTES.ROOT);
        }
    };

    return <></>;
};

export default Dashboard;
